import React from 'react'

import config from '../config.js'

import axios from 'axios'

import { Link, NavLink, Redirect, Route, Switch } from 'react-router-dom'

import Chapters from './Chapters'
import Cookbooks from './Cookbooks'
import Feed from './Feed'
import Friends from './Friends'
import Invites from './Invites'
import Messages from './Messages'
import Recipes from './Recipes'
import Recipe from './Recipe'
import ToolbarBackButton from './ToolbarBackButton'

import { urlify } from '../Helpers/urls'

class MyFriends extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sessionId: props.sessionId,
      aid: props.accountId,

      userIdentifier: urlify(props.userName),
      userName: props.userName,
      userNameDisplay: props.userNameDisplay,
      userAvatar: props.userAvatar,

      currentFriend: undefined,

      friends: undefined,
      cookbooks: undefined,
      chapters: [],
      recipes: [],
      recipe: []

      //debugging: ''
    }
  }

  callingAjax = false

  getFriends = () => {
    let friends = undefined

    if (this.state.friends !== undefined) {
      friends = this.state.friends
    } else {
      this.apiGetFriends(this.state.aid)
    }

    return friends
  }

  getFriend = friendIdentifier => {
    let friend = undefined

    if (this.state.friends) {
      friend = this.state.friends.filter(
        item => item.identifier === friendIdentifier
      )

      if (friend.length > 0) {
        friend = friend[0]
      }
    } else {
      this.apiGetFriends(this.state.aid)
    }

    return friend
  }

  getCookbooks = friendIdentifier => {
    let cookbooks = undefined

    if (
      this.state.cookbooks === undefined ||
      this.state.currentFriend !== friendIdentifier
    ) {
      this.apiGetCookbooks(friendIdentifier)
    } else {
      cookbooks = this.state.cookbooks
    }

    return cookbooks
  }

  getCookbook = (friendIdentifier, cookbookIdentifier) => {
    let cookbook = undefined

    if (
      this.state.cookbooks === undefined ||
      this.state.currentFriend !== friendIdentifier
    ) {
      this.apiGetCookbooks(friendIdentifier)
    } else {
      cookbook = this.state.cookbooks.filter(
        item => item.identifier === cookbookIdentifier
      )

      if (cookbook.length > 0) {
        // If by some weird situation there are more than one cookbooks with the same title, return only the first
        cookbook = cookbook[0]
      } else cookbook = null
    }

    return cookbook
  }

  getChapters = (friendIdentifier, cookbookIdentifier) => {
    const cookbook = this.getCookbook(friendIdentifier, cookbookIdentifier)

    let chapters = undefined

    if (cookbook) {
      if (cookbook.chaptersFetched !== true) {
        this.apiGetChapters(
          friendIdentifier,
          cookbook.uuid,
          cookbook.identifier
        )
      } else {
        chapters = this.state.chapters.filter(
          item => item.cookbook === cookbookIdentifier
        )

        // If there are chapters, make sure we've loaded the recipes
        if (chapters && chapters.length > 0) {
          chapters.forEach((chapter, index) => {
            if (chapter.recipesFetched !== true) {
              this.apiGetRecipes(
                friendIdentifier,
                cookbookIdentifier,
                chapter.uuid,
                chapter.identifier
              )
            } else {
              chapter.recipes = this.getRecipes(
                friendIdentifier,
                cookbookIdentifier,
                chapter.identifier
              )
            }
          })
        }
      }
    }

    return chapters
  }

  getChapter = (friendIdentifier, cookbookIdentifier, chapterIdentifier) => {
    let chapters = this.state.chapters.filter(
      item => item.identifier === chapterIdentifier
    )
    chapters = chapters.filter(item => item.cookbook === cookbookIdentifier)

    let chapter = undefined

    if (chapters.length > 0) {
      // If by some weird situation there are more than one cookbooks with the same name
      // Which ALSO have chapters with the same name, return only the first
      chapter = chapters[0]
    } else {
      const cookbook = this.getCookbook(friendIdentifier, cookbookIdentifier)

      if (cookbook) {
        if (cookbook.chaptersFetched !== true) {
          this.apiGetChapters(
            friendIdentifier,
            cookbook.uuid,
            cookbook.identifier
          )
        } else chapter = null
      }
    }

    return chapter
  }

  getRecipes = (friendIdentifier, cookbookIdentifier, chapterIdentifier) => {
    const chapter = this.getChapter(
      friendIdentifier,
      cookbookIdentifier,
      chapterIdentifier
    )

    let recipes = undefined

    if (chapter) {
      if (chapter.recipesFetched !== true) {
        this.apiGetRecipes(
          friendIdentifier,
          cookbookIdentifier,
          chapter.uuid,
          chapter.identifier
        )
      } else {
        recipes = this.state.recipes.filter(
          item => item.cookbook === cookbookIdentifier
        )
        recipes = recipes.filter(item => item.chapter === chapterIdentifier)
      }
    } else {
      const cookbook = this.getCookbook(friendIdentifier, cookbookIdentifier)

      if (cookbook) {
        if (cookbook.chaptersFetched !== true) {
          this.apiGetChapters(
            friendIdentifier,
            cookbook.uuid,
            cookbook.identifier
          )
        } else {
          recipes = []
        }
      } else {
        recipes = []
      }
    }

    return recipes
  }

  getRecipe = (
    friendIdentifier,
    cookbookIdentifier,
    chapterIdentifier,
    recipeIdentifier
  ) => {
    let recipeShort = this.state.recipes.filter(
      item => item.identifier === recipeIdentifier
    )
    recipeShort = recipeShort.filter(item => item.chapter === chapterIdentifier)
    recipeShort = recipeShort.filter(
      item => item.cookbook === cookbookIdentifier
    )

    let recipe = undefined

    if (recipeShort.length > 0) {
      // If by some weird situation there are more than one recipes with the same name
      // Which ALSO belong to chapters with the same name
      // Which ALSO belong to cookbooks with the same name, use only the first (recipe[0])
      const recipeShortId = recipeShort[0].uuid

      if (
        this.state.recipe.length === 0 ||
        this.state.recipe.uuid !== recipeShortId
      ) {
        this.apiGetRecipe(friendIdentifier, recipeShortId)
      } else {
        recipe = this.state.recipe
      }
    } else {
      const chapter = this.getChapter(
        friendIdentifier,
        cookbookIdentifier,
        chapterIdentifier
      )

      if (chapter !== undefined) {
        if (chapter.recipesFetched !== true) {
          this.apiGetRecipes(
            friendIdentifier,
            cookbookIdentifier,
            chapter.uuid,
            chapter.identifier
          )
        } else recipe = null
      } else {
        const cookbook = this.getCookbook(friendIdentifier, cookbookIdentifier)

        if (cookbook) {
          if (cookbook.chaptersFetched !== true) {
            this.apiGetChapters(
              friendIdentifier,
              cookbook.uuid,
              cookbook.identifier
            )
          } else recipe = null
        } else recipe = null
      }
    }

    return recipe
  }

  // See if a chapter has already been loaded into state (current use is to prevent double-loading)
  chapterInState = chapterId => {
    let chapter = this.state.chapters.filter(item => item.uuid === chapterId)

    if (chapter.length > 0) return true
    else return false
  }

  // See if a list recipe has already been loaded into state (current use is to prevent double-loading)
  recipeInState = recipeId => {
    let recipe = this.state.recipes.filter(item => item.uuid === recipeId)

    if (recipe.length > 0) return true
    else return false
  }

  // Given a base path and a recipe ID, get the recipe's path so we can create a link to it
  getRecipePathById = (recipeBasePath, recipeId, friendIdentifier) => {
    let recipe = this.state.recipes.filter(item => item.uuid === recipeId)
    let path = null

    var n = recipeBasePath.indexOf(':')
    recipeBasePath = recipeBasePath.substring(
      0,
      n !== -1 ? n : recipeBasePath.length
    )

    if (friendIdentifier && recipe.length > 0) {
      path =
        recipeBasePath +
        friendIdentifier +
        '/cookbooks/' +
        recipe[0].cookbook +
        '/' +
        recipe[0].chapter +
        '/' +
        recipe[0].identifier
    }
    return path
  }

  apiGetFriends = accountId => {
    if (accountId && this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/friends?sid=' +
            this.state.sessionId +
            '&aid=' +
            accountId,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const friendsJson = response.data.results
            const friendsCount = friendsJson.length

            // this.setState((state, props) => ({
            //   debugging:
            //     state.debugging +
            //     'apiGetFriends results: ' +
            //     JSON.stringify(response.data) +
            //     ' '
            // }))

            let sortedFriends = []

            if (friendsCount > 0) {
              // Fetch the friends and put each bit of JSON into an array
              for (let i = 0; i < friendsCount; i++) {
                // Convert the username and store it as a URL identifier
                friendsJson[i].identifier = urlify(friendsJson[i].username)

                sortedFriends.push(friendsJson[i])
              }

              // Sort the array
              sortedFriends.sort(function(a, b) {
                if (a.identifier > b.identifier) {
                  return 1
                } else if (a.identifier === b.identifier) {
                  return 0
                } else return -1
              })
            }

            this.setState((state, props) => ({
              friends: sortedFriends
            }))
          },
          error => {
            this.callingAjax = false

            // this.setState((state, props) => ({
            //   debugging: this.state.debugging + error
            // }))
            console.log(error)
          }
        )
    }
  }

  apiGetCookbooks = friendIdentifier => {
    let friend = ''

    if (friendIdentifier === this.state.userIdentifier) {
      friend = {
        accountId: this.state.aid // We only need the user's ID in the calls below
      }
    } else {
      friend = this.getFriend(friendIdentifier)
    }

    if (friend && this.callingAjax === false) {
      // None of the following code makes any sense without a valid friend
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/friends/cookbooks?sid=' +
            this.state.sessionId +
            '&fid=' +
            friend.accountId,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const cookbooksJson = response.data.results
            const cookbooksCount = cookbooksJson.length

            let sortedCookbooks = []

            if (cookbooksCount > 0) {
              // Fetch the chapters for this cookbook, then
              // put each bit of JSON into an array
              for (let i = 0; i < cookbooksCount; i++) {
                // Convert the title and store it as a URL identifier
                cookbooksJson[i].identifier = urlify(cookbooksJson[i].title)
                cookbooksJson[i].friendIdentifier = friendIdentifier

                sortedCookbooks.push(cookbooksJson[i])
              }

              // Sort the array
              sortedCookbooks.sort(function(a, b) {
                return (
                  parseFloat(a['displayOrder']) - parseFloat(b['displayOrder'])
                )
              })
            }

            this.setState((state, props) => ({
              currentFriend: friendIdentifier,
              cookbooks: sortedCookbooks,
              chapters: [], // We need to empty out the chapters because they might still have stuff from other friends
              recipes: [] // We need to empty out the recipes because they might still have stuff from other friends
            }))
          },
          error => {
            this.callingAjax = false

            // this.setState((state, props) => ({
            //   debugging: this.state.debugging + error
            // }))
            console.log(error)
          }
        )
    }
  }

  apiGetChapters = (friendIdentifier, cookbookUuid, cookbookIdentifier) => {
    let friend = ''
    if (friendIdentifier === this.state.userIdentifier) {
      friend = {
        accountId: this.state.aid // We only need the user's ID in the calls below
      }
    } else {
      friend = this.getFriend(friendIdentifier)
    }

    if (friend && this.callingAjax === false) {
      // None of the following code makes any sense without a valid friend
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/friends/chapters?sid=' +
            this.state.sessionId +
            '&fid=' +
            friend.accountId +
            '&cbid=' +
            cookbookUuid,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const chaptersJson = response.data.results
            const chaptersCount = chaptersJson.length

            let sortedChapters = []

            // Store some data with each chapter and put each bit of JSON into a new array
            if (chaptersCount > 0) {
              for (let i = 0; i < chaptersCount; i++) {
                if (!this.chapterInState(chaptersJson[i].uuid)) {
                  // Convert the title and store it as a URL identifier
                  chaptersJson[i].identifier = urlify(chaptersJson[i].title)
                  chaptersJson[i].friendIdentifier = friendIdentifier

                  // Add the cookbook name to each chapter
                  chaptersJson[i].cookbook = cookbookIdentifier

                  sortedChapters.push(chaptersJson[i])
                }
              }

              // Sort the array
              sortedChapters.sort(function(a, b) {
                return (
                  parseFloat(a['displayOrder']) - parseFloat(b['displayOrder'])
                )
              })

              // Add a flag to the cookbook to show we've fetched the chapters
              const cookbook = this.getCookbook(
                friendIdentifier,
                cookbookIdentifier
              )
              if (cookbook) {
                cookbook.chaptersFetched = true
              }

              // Add the array to the existing array of chapters
              this.setState((state, props) => ({
                cookbooks: state.cookbooks,
                chapters: state.chapters.concat(sortedChapters)
              }))
            } else {
              // Add a flag to the cookbook to show we've fetched the chapters
              const cookbook = this.getCookbook(
                friendIdentifier,
                cookbookIdentifier
              )
              if (cookbook) {
                cookbook.chaptersFetched = true
              }

              // Add the array to the existing array of chapters
              this.setState((state, props) => ({
                cookbooks: state.cookbooks
              }))
            }
          },
          error => {
            this.callingAjax = false

            // this.setState((state, props) => ({
            //   debugging: this.state.debugging + error
            // }))
            console.log(error)
          }
        )
    }
  }

  apiGetRecipes = (
    friendIdentifier,
    cookbookIdentifier,
    chapterUuid,
    chapterIdentifier
  ) => {
    let friend = ''
    if (friendIdentifier === this.state.userIdentifier) {
      friend = {
        accountId: this.state.aid // We only need the user's ID in the calls below
      }
    } else {
      friend = this.getFriend(friendIdentifier)
    }

    if (friend && this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/friends/recipes?sid=' +
            this.state.sessionId +
            '&fid=' +
            friend.accountId +
            '&chid=' +
            chapterUuid,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const recipesJson = response.data.results
            const recipesCount = recipesJson.length

            let sortedRecipes = []

            // Store some data with each recipe and put each bit of JSON into a new array
            if (recipesCount > 0) {
              for (let i = 0; i < recipesCount; i++) {
                if (!this.recipeInState(recipesJson[i].uuid)) {
                  // Convert the title and store it as a URL identifier
                  recipesJson[i].identifier = urlify(recipesJson[i].title)
                  recipesJson[i].friendIdentifier = friendIdentifier

                  // Add the cookbook name to each recipe
                  recipesJson[i].cookbook = cookbookIdentifier
                  // Add the chapter name to each recipe
                  recipesJson[i].chapter = chapterIdentifier

                  sortedRecipes.push(recipesJson[i])
                }
              }

              // Sort the array
              sortedRecipes.sort(function(a, b) {
                return (
                  parseFloat(a['displayOrder']) - parseFloat(b['displayOrder'])
                )
              })

              // Add a flag to the chapter to show we've fetched the recipes
              // Also store the recipe count with the chapter
              const chapter = this.getChapter(
                friendIdentifier,
                cookbookIdentifier,
                chapterIdentifier
              )
              if (chapter != null) {
                chapter.recipesFetched = true
                chapter.recipesCount = recipesCount
              }

              // Add the array to the existing array of recipes
              this.setState((state, props) => ({
                chapters: state.chapters,
                recipes: state.recipes.concat(sortedRecipes)
              }))
            } else {
              // Add a flag to the chapter to show we've fetched the recipes
              const chapter = this.getChapter(
                friendIdentifier,
                cookbookIdentifier,
                chapterIdentifier
              )
              if (chapter !== undefined) {
                chapter.recipesFetched = true

                // Update the chapters state
                this.setState((state, props) => ({
                  chapters: state.chapters
                }))
              }
            }
          },
          error => {
            this.callingAjax = false

            // this.setState((state, props) => ({
            //   debugging: this.state.debugging + error
            // }))
            console.log(error)
          }
        )
    }
  }

  apiGetRecipe = (friendIdentifier, recipeId) => {
    let friend = ''
    if (friendIdentifier === this.state.userIdentifier) {
      friend = {
        accountId: this.state.aid // We only need the user's ID in the calls below
      }
    } else {
      friend = this.getFriend(friendIdentifier)
    }

    if (friend && this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/friends/recipe?sid=' +
            this.state.sessionId +
            '&fid=' +
            friend.accountId +
            '&rid=' +
            recipeId,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const recipeJson = response.data.result

            if (recipeJson.recipe) {
              this.setState((state, props) => ({
                recipe: recipeJson.recipe
              }))
            }
          },
          error => {
            this.callingAjax = false

            // this.setState((state, props) => ({
            //   debugging: this.state.debugging + error
            // }))
            console.log(error)
          }
        )
    }
  }

  render() {
    return (
      <div>
        {/*<div className="debugging">{this.state.debugging}</div>*/}
        <nav className="panel-toolbar">
          <ul>
            <li>
              <ToolbarBackButton />
            </li>
            {/*<li>
              <Link to={this.props.match.url + '/feed'}>
                <span className="material-icons md-36">home</span>
                <br />
                <span className="icon-text">Home</span>
              </Link>
            </li>*/}
            <li>
              <NavLink
                to={this.props.match.url + '/list'}
                activeClassName="active"
              >
                <span className="material-icons md-36">group</span>
                <br />
                <span className="icon-text">My Friends</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to={this.props.match.url + '/invites'}
                activeClassName="active"
              >
                <span className="material-icons md-36">person_add</span>
                <br />
                <span className="icon-text">Add Friends</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to={this.props.match.url + '/messages'}
                activeClassName="active"
              >
                <span className="material-icons md-36">forum</span>
                <br />
                <span className="icon-text">Messages</span>
              </NavLink>
            </li>
          </ul>
        </nav>

        <Route
          path={`${
            this.props.match.url
          }/list/:friendIdentifier/cookbooks/:cookbookIdentifier?/:chapterIdentifier?/:recipeIdentifier?`}
          render={({ match }) => {
            let friendLink,
              cookbookLink,
              chapterLink,
              recipeTitle = ''

            const friend = this.getFriend(match.params.friendIdentifier)

            if (friend && friend.name) {
              let cookbook,
                chapter,
                recipe = null

              if (match.params.cookbookIdentifier)
                cookbook = this.getCookbook(
                  match.params.friendIdentifier,
                  match.params.cookbookIdentifier
                )
              if (match.params.chapterIdentifier)
                chapter = this.getChapter(
                  match.params.friendIdentifier,
                  match.params.cookbookIdentifier,
                  match.params.chapterIdentifier
                )
              if (match.params.recipeIdentifier)
                recipe = this.getRecipe(
                  match.params.friendIdentifier,
                  match.params.cookbookIdentifier,
                  match.params.chapterIdentifier,
                  match.params.recipeIdentifier
                )

              if (cookbook)
                friendLink = (
                  <li>
                    <Link
                      to={
                        `${this.props.match.url}/list/` +
                        match.params.friendIdentifier +
                        '/cookbooks'
                      }
                    >
                      {friend.name}
                    </Link>
                  </li>
                )
              else
                friendLink = (
                  <li>
                    <span>{friend.name}</span>
                  </li>
                )
              if (cookbook) {
                if (chapter)
                  cookbookLink = (
                    <li>
                      <Link
                        to={
                          `${this.props.match.url}/list/` +
                          match.params.friendIdentifier +
                          '/cookbooks/' +
                          match.params.cookbookIdentifier
                        }
                      >
                        {cookbook.title}
                      </Link>
                    </li>
                  )
                else
                  cookbookLink = (
                    <li>
                      <span>{cookbook.title}</span>
                    </li>
                  )
              }
              if (chapter) {
                if (recipe)
                  chapterLink = (
                    <li>
                      <Link
                        to={
                          `${this.props.match.url}/list/` +
                          match.params.friendIdentifier +
                          '/cookbooks/' +
                          match.params.cookbookIdentifier +
                          '/' +
                          match.params.chapterIdentifier
                        }
                      >
                        {chapter.title}
                      </Link>
                    </li>
                  )
                else
                  chapterLink = (
                    <li>
                      <span>{chapter.title}</span>
                    </li>
                  )
              }
              if (recipe) {
                recipeTitle = (
                  <li>
                    <span>{recipe.name}</span>
                  </li>
                )
              }

              return (
                <nav className="breadcrumbs">
                  <ol>
                    <li>
                      <Link to={`${this.props.match.url}/list`}>
                        My Friends
                      </Link>
                    </li>
                    {friendLink}
                    {cookbookLink}
                    {chapterLink}
                    {recipeTitle}
                  </ol>
                </nav>
              )
            } else {
              return ''
            }
          }}
        />

        <Switch>
          <Route
            exact
            path={`${this.props.match.url}`}
            render={() => <Redirect to={`${this.props.match.url}/list`} />}
          />
          <Route
            exact
            path={`${this.props.match.url}/list`}
            render={({ match }) => {
              const user = {
                accountId: this.state.aid,
                name: this.state.userNameDisplay,
                identifier: urlify(this.state.userName),
                avatarUrl: this.state.userAvatar
              }
              return (
                <Friends
                  user={user}
                  friends={this.getFriends()}
                  friendsPath={this.props.match.url}
                />
              )
            }}
          />

          {/*
            // The following route is a duplicate of the normal friends cookbook route (but using the user's identifier) so we can include the user's own cookbooks
            // It has to be first so it's caught before the general case
            http://localhost:3000/danoaks/friends/list/brian-oaks/cookbooks/brians-recipes
          */}
          <Route
            exact
            path={
              `${this.props.match.url}/list/` +
              this.state.userName +
              '/cookbooks'
            }
            render={({ match }) => {
              return (
                <Cookbooks
                  baseUrl={match.url}
                  theme={this.props.theme}
                  cookbooks={this.getCookbooks(this.state.userIdentifier)}
                  title={'Cookbooks You Have Shared'}
                  context={'SharedRecipes'}
                />
              )
            }}
          />
          <Route
            exact
            path={`${this.props.match.url}/list/:friendIdentifier/cookbooks`}
            render={({ match }) => (
              <Cookbooks
                context={'MyFriends'}
                theme={this.props.theme}
                baseUrl={match.url}
                returnUrl={this.props.match.url + '/list'}

                accountId={this.props.accountId}
                friendId={
                  this.getFriend(match.params.friendIdentifier)
                    ? this.getFriend(match.params.friendIdentifier).accountId
                    : ''
                }

                cookbooks={this.getCookbooks(match.params.friendIdentifier)}
                title={
                  this.getFriend(match.params.friendIdentifier)
                    ? 'Cookbooks Shared by ' +
                      this.getFriend(match.params.friendIdentifier).name
                    : ''
                }
              />
            )}
          />

          <Route
            exact
            path={`${
              this.props.match.url
            }/list/:friendIdentifier/cookbooks/:cookbookIdentifier`}
            render={({ match }) => {
              return (
                <Chapters
                  cookbookUrl={match.url}
                  cookbook={this.getCookbook(
                    match.params.friendIdentifier,
                    match.params.cookbookIdentifier
                  )}
                  chapters={this.getChapters(
                    match.params.friendIdentifier,
                    match.params.cookbookIdentifier
                  )}
                />
              )
            }}
          />
          <Route
            exact
            path={`${
              this.props.match.url
            }/list/:friendIdentifier/cookbooks/:cookbookIdentifier/:chapterIdentifier`}
            render={({ match }) => {
              return (
                <Recipes
                  chapterUrl={match.url}
                  chapter={this.getChapter(
                    match.params.friendIdentifier,
                    match.params.cookbookIdentifier,
                    match.params.chapterIdentifier
                  )}
                  recipes={this.getRecipes(
                    match.params.friendIdentifier,
                    match.params.cookbookIdentifier,
                    match.params.chapterIdentifier
                  )}
                />
              )
            }}
          />
          <Route
            exact
            path={`${
              this.props.match.url
            }/list/:friendIdentifier/cookbooks/:cookbookIdentifier/:chapterIdentifier/:recipeIdentifier/:recipeId`}
            render={({ match }) => (
              <Recipe
                recipe={this.getRecipe(
                  match.params.friendIdentifier,
                  match.params.cookbookIdentifier,
                  match.params.chapterIdentifier,
                  match.params.recipeIdentifier
                )}
                friendIdentifier={match.params.friendIdentifier}
                userLoggedIn={true}
              />
            )}
          />

          <Route
            exact
            path={`${this.props.match.url}/feed`}
            render={({ match }) => <Feed />}
          />

          <Route
              path={`${this.props.match.url}/invites`}
              render={({ match }) => (
                  <Invites
                      device={this.props.device}
                      version={this.props.version}
                      aid={this.state.aid}
                      sessionId={this.state.sessionId}
                      friends={this.getFriends()}
                      baseUrl={`${this.props.match.url}/invites`}
                  />
              )}
          />

          <Route
            path={`${this.props.match.url}/messages`}
            render={({ match }) => (
              <Messages
                match={match}
                device={this.props.device}
                version={this.props.version}
                aid={this.state.aid}
                userIdentifier={this.state.userIdentifier}
                userName={this.state.userName}
                friends={this.getFriends()}
              />
            )}
          />
        </Switch>
      </div>
    )
  }
}

export default MyFriends



// WEBPACK FOOTER //
// ./src/Components/MyFriends.js